<!-- =========================================================================================
  File Name: UserList.vue
  Description: Travel Post Report page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div id="user-service-unit-screenshots-list">

    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="refreshFilters">

      <div class="vx-row">

        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Service Unit</label>
          <v-select
            :options="optionServiceUnits"
            :clearable="false"
            v-model="serviceUnits"
            name="serviceUnit"
            class="mb-4 md:mb-0"/>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Date From</label>
          <flat-pickr
            style="margin-top: 0px!important;"
            name="dateFrom"
            class="w-full mt-4 flatpickr-input"
            :clearable="false"
            :config="configdateTimePicker"
            v-model="dateFrom"
            placeholder="Please Select Date"/>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Date To</label>
          <flat-pickr
            style="margin-top: 0px!important;"
            name="dateTo"
            class="w-full mt-4 flatpickr-input"
            :clearable="false"
            :config="configdateTimePicker"
            v-model="dateTo"
            placeholder="Please Select Date"/>
        </div>

      </div>


    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ offset  }} - {{ limit }} of {{ totalResultCount }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <!--              <vs-dropdown-item @click="setLimit(1)">-->
              <!--                <span>1</span>-->
              <!--              </vs-dropdown-item>-->
              <vs-dropdown-item @click="setLimit(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="setLimit(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="setLimit(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="setLimit(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!--        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"-->
        <!--                  @input="updateSearchQuery" placeholder="Search..."/>-->

        <!-- ACTION - DROPDOWN -->
        <!--        <vs-dropdown vs-trigger-click class="cursor-pointer">-->
        <!--          <div-->
        <!--            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">-->
        <!--            <span class="mr-2 leading-none">Actions</span>-->
        <!--            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>-->
        <!--          </div>-->

        <!--          <vs-dropdown-menu>-->

        <!--            <vs-dropdown-item>-->
        <!--                <span class="flex items-center">-->
        <!--                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>-->
        <!--                  <span><a @click="downloadPDF" @click.stop.prevent class="text-inherit hover:text-primary"> Download PDF </a></span>-->
        <!--                </span>-->
        <!--            </vs-dropdown-item>-->

        <!--            <vs-dropdown-item>-->
        <!--                <span class="flex items-center">-->
        <!--                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2"/>-->
        <!--                   <span><a @click="downloadExcel" @click.stop.prevent class="text-inherit hover:text-primary"> Download CSV </a></span>-->
        <!--                </span>-->
        <!--            </vs-dropdown-item>-->

        <!--          </vs-dropdown-menu>-->
        <!--        </vs-dropdown>-->

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="getDataTable"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"

        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage"/>

    </div>

    <!--Create New-->
    <vs-popup class="vs-view-popup" fullscreen title="Add New Service Unit"  :active.sync="isPopup">
      <screen-shot v-if="isPopup" :screenshot ="screenshot"></screen-shot>
    </vs-popup>


  </div>

</template>

<script>
    import {AgGridVue} from 'ag-grid-vue'
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import vSelect from 'vue-select'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Datepicker from 'vuejs-datepicker';

    // Import Request Function
    import {sendRequest} from '@/request';

    // Cell Renderer
    import CellRendererActions from './cell-renderer/CellRendererActions.vue'

    //Popups
    import ScreenShot from './view-screenshot/screenShot.vue'

    export default {
        name: "ScreenshotsList",
        components: {
            AgGridVue,
            vSelect,
            flatPickr,
            Datepicker,

            // Cell Renderer
            CellRendererActions,

            //Popups
            ScreenShot,
        },
        data() {
            return {
                test: true,
                datetime: null,
                configdateTimePicker:
                    {
                        enableTime: false,
                        dateFormat: 'Y-m-d',
                        maxDate: new Date()
                    },
                totalPages: 0,
                currentPage: 1,
                getDataTable: false,
                totalResultCount: 0,
                offset: 0,
                limit: 10,
                resetColFilters: '',

                dateTo: '',
                dateFrom: '',
                serviceUnits: {label: 'All', value: ''},
                optionServiceUnits: [],

                searchQuery: '',

                isPopup: false,
                screenshot:'',

                // AgGrid
                gridApi: null,
                gridOptions: {},
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    suppressMenu: true
                },
                columnDefs: [
                    {
                        headerName: 'No',
                        field: 'no',
                        width: 125,
                        filter: true,
                        checkboxSelection: true,
                        headerCheckboxSelectionFilteredOnly: true,
                        headerCheckboxSelection: true
                    },
                    {
                        headerName: 'Generated ID',
                        field: 'generatedID',
                        filter: true,
                        width: 200,
                    },
                    {
                        headerName: 'Device ID',
                        field: 'deviceID',
                        filter: true,
                        width: 200
                    },
                    {
                        headerName: 'Device Type',
                        field: 'deviceType',
                        width: 150,
                        cellClass: 'text-center'
                    },
                    {
                        headerName: 'Create Date',
                        field: 'createDate',
                        filter: true,
                        width: 200
                    },
                    {
                        headerName: 'Screenshot',
                        field: 'transactions',
                        width: 150,
                        cellRendererFramework: 'CellRendererActions',
                        cellClass: 'text-center'
                    }

                ],

                // Cell Renderer Components
                components: {
                    CellRendererActions,
                }
            }
        },
        watch: {


            'serviceUnits': function (value, old_vlaue) {
                if(value.value!=''){
                    this.loadTableData()
                }
            },

            'dateFrom': function (value, old_vlaue) {
                if(this.dateFrom!='' && this.dateTo!=''){
                    this.loadTableData()
                }
            },

            'dateTo': function (value, old_vlaue) {
                if(this.dateFrom!='' && this.dateTo!=''){
                    this.loadTableData()
                }
            },

            'currentPage': function (value, old_vlaue) {
                this.offset = (value - 1) * this.limit
                // alert('value : ' + value + ' | offset : ' + this.offset + ' | limit : '+this.limit)
                this.loadTableData()
            },

        },
        computed: {

        },
        methods: {
            refreshFilters(card){
                this.dateTo = ''
                this.dateFrom = ''
                this.serviceUnits= {label: 'All', value: ''}
                this.loadTableData()
                card.removeRefreshAnimation()  // remove refresh animation
            },

            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },

            getDefaultValues() {

                try {
                    sendRequest('loadownserviceunits', {}, 'get', 1).then(response => {
                        if (response.success) {
                            this.optionServiceUnits = response.data
                            this.optionServiceUnits.splice(0, 0, {label: 'All', value: ''})
                        } else {
                            // Notify Response
                            this.$vs.notify({
                                title: 'Oops :(',
                                text: 'Page initializing failure',
                                color: 'danger',
                                position: 'top-right'
                            })
                        }
                    });
                } catch (error) {
                    console.log(error)
                }
            },

            // Get Report Data
            loadTableData() {

                const dataSet = 'offset='+this.offset
                    +'&limit='+this.limit
                    +'&serviceUnit='+this.serviceUnits.value
                    +'&dateFrom='+this.dateFrom
                    +'&dateTo='+this.dateTo

                // alert(dataSet)
                // console.log(dataSet)
                try {
                    this.$vs.loading()
                    sendRequest('user/userserviceunitscreenshot?'+dataSet, {}, 'get', 1).then(response => {
                        // alert(response.data.totalResultCount)
                        this.$vs.loading.close()
                        if (response.success) {
                            this.getDataTable = response.data.responseData
                            this.totalResultCount = response.data.totalResultCount
                            this.totalPages = response.data.pageCount

                        } else {
                            // Notify Response
                            this.$vs.notify({
                                title: 'Oops :(',
                                text: 'Report loading failure',
                                color: 'danger',
                                position: 'top-right'
                            })
                        }
                    });

                } catch (error) {
                    console.log(error)
                }
            },


            // Set Limit
            setLimit(limit) {
                this.limit = limit
                this.loadTableData()
            },

            loadInitialData(){
                this.getDefaultValues()
                this.loadTableData()
            }
        },
        mounted() {
        },
        created() {
            this.loadInitialData()
        }
    }

</script>

<style lang="scss">
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
</style>

<style lang="scss">
  .vs-view-popup {
    padding: 25px 25px 0px 25px;
  }

  .con-vs-popup.fullscreen .vs-popup{
    height: auto!important;
    width: auto!important;
  }


</style>
